export const skipToContent = {
    onDocumentLoad
}

const onDocumentLoad = function() {
  /*skip to content*/
  /*skip to main content*/
  let main = document.querySelectorAll("main");
  let focusable = main[0].querySelectorAll("button, [href], select, textarea");
  let firstFocusable = focusable[0];
  let skipToContent = document.getElementById("skipToContent");
  skipToContent.addEventListener("click", function () {
    firstFocusable.focus();
  });
}